export default {
    setConnectedAccounts(state, payload) {
        state.connectedLinkedInAccounts = payload;
    },
    setClientDetails(state, payload) {
       state.authUrl = payload;
    }
}